export const SET_CONSTANTS = '@general/SET_CONSTANTS' as const;
export const SET_BLOCKCHAIN_STATE = '@general/SET_BLOCKCHAIN_STATE' as const;
